import React from "react";
import { getMeristemContext } from "src/utils/meristemContext";

export const DisclaimerLink = ({
  href,
  children,
}: {
  href: string;
  children?: React.ReactNode;
}) => (
  <a href={href} className="footer-link" target="_blank" rel="noreferrer">
    {children}
  </a>
);
const DisclaimerLinks = {
  TocLink: "https://web.noom.com/terms-and-conditions-of-use/",
  PrivacyLink: "https://web.noom.com/noom-privacy-policy/",
  ResearchLink: "https://web.noom.com/research-policy/",
  GooglePrivacyLink: "https://policies.google.com/privacy",
  HIPAALink: "https://web.noom.com/hipaa-notice/",
  GoogleTocLink: "https://policies.google.com/terms",
  SupportLink: "https://web.noom.com/support/contact-support",
  EmailHMSupportLink: "mailto:hmsupport@noom.com",
  EmailSupportLink: "mailto:programsupport@noom.com",
};
const localeSpecificDisclaimerLinks = {
  es: {
    TocLink: "https://web2.noom.com/es/es-tos/",
    PrivacyLink: "https://web2.noom.com/es/es-privacy-policy/",
    ResearchLink: "https://web2.noom.com/es/research-policy-spanish/",
    SupportLink:
      "https://web2.noom.com/es/support/support-premium-features/contact-support/",
    EmailSupportLink: "mailto:programsupport-es@noom.com",
  },
  de: {
    TocLink: "https://web2.noom.com/de/de-tos/",
    PrivacyLink: "https://web2.noom.com/de/de-privacy-policy/",
    ResearchLink: "https://web2.noom.com/de/research-policy-german/",
    SupportLink:
      "https://web2.noom.com/de/support/kundenservice-premium-funktionen/kontaktiere-support/",
    EmailSupportLink: "mailto:support-de@noom.com",
  },
  ja: {
    TocLink: "https://web2.noom.com/jp/jp-tos/",
    PrivacyLink: "https://web2.noom.com/jp/jp-privacy-policy/",
    EmailSupportLink: "mailto:programsupport-ja@noom.com",
  },
};
// Merge locale-specific links with default links
const { language_code } = getMeristemContext();
export const disclaimerUrls: Record<string, string> = {
  ...DisclaimerLinks,
  ...localeSpecificDisclaimerLinks[language_code],
};

// Generate a map of DisclaimerLinks for convenient interpolation of disclaimer links in a <Text /> component.
export const disclaimerLinks: Record<string, typeof DisclaimerLink> =
  Object.entries(disclaimerUrls).reduce((map, [linkName, href]) => {
    // eslint-disable-next-line no-param-reassign
    map[linkName] = <DisclaimerLink href={href} />;
    return map;
  }, {});
